module.exports = function() {
	return new Worker(__webpack_public_path__ + "12d597f54f8e134d96cb.sampling-points.wrkr.js");
};